import useStore from "components/ui/Context"
import Image from "next/legacy/image"
import { useState } from "react"

function Card3x1({ is_live, name, thumbnail, start_time, status, is_premium, hideText, package_type }) {
  const setModalLive = useStore().setModalLive
  const [srcImage, setSrcImage] = useState(thumbnail)

  function nextPath() {
    if (status !== "live" && is_live) {
      setModalLive({
        show: true,
        isVod: true,
        info: {
          title: name,
          start_time
        }
      })
    }
  }

  return (
    <div onClick={nextPath}>
      <div className="relative wapper__play">
        <div className="fix_img gradient_topic relative bg-[#202020] rounded-xl border border-transparent hover:border-white">
          <Image
            className="rounded-xl object-cover h-full w-full aspect-[8/3]"
            width={600}
            height={225}
            src={srcImage}
            alt={name}
            onError={() => setSrcImage("/placeholder_video.svg")}
          />
        </div>
        {!hideText && (
          <span className="absolute rounded-[20px] text-sm md:text-base text-[#FAFAF9] bg-[#1313133D] backdrop-blur-xl bottom-3 font-medium py-1 px-3 z-10 left-3">
            {name}
          </span>
        )}
      </div>
    </div>
  )
}
export default Card3x1
